function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#243143"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 11V6a1 1 0 10-2 0v5H6a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5z",
  fill: "#fff"
});

function SvgAddCountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjEyIiBmaWxsPSIjMjQzMTQzIiAvPgogICAgPHBhdGggZD0iTTEzIDExVjZDMTMgNS40NDc3MiAxMi41NTIzIDUgMTIgNUMxMS40NDc3IDUgMTEgNS40NDc3MiAxMSA2VjExSDZDNS40NDc3MiAxMSA1IDExLjQ0NzcgNSAxMkM1IDEyLjU1MjMgNS40NDc3MiAxMyA2IDEzSDExVjE4QzExIDE4LjU1MjMgMTEuNDQ3NyAxOSAxMiAxOUMxMi41NTIzIDE5IDEzIDE4LjU1MjMgMTMgMThWMTNIMThDMTguNTUyMyAxMyAxOSAxMi41NTIzIDE5IDEyQzE5IDExLjQ0NzcgMTguNTUyMyAxMSAxOCAxMUgxM1oiIGZpbGw9IndoaXRlIiAvPgo8L3N2Zz4K";
export { SvgAddCountIcon as ReactComponent };